import React from 'react'
import colors from '../../constants/colors'
import Box from '../Box'
import Text from '../Text'
import { DividerProps } from './Divider.types'
import { StyledDivider } from './styled'

// Will The test Soon
/* istanbul ignore next */
const Divider: React.FC<DividerProps> = ({
  children,
  orientation = 'horizontal',
  ...restProps
}) => (
  <StyledDivider
    backgroundColor={!children && colors.black10}
    {...restProps}
    aria-label='divider-wrapper'
  >
    <Box paddingX={orientation === 'horizontal' && '12px'}>
      <Text variant='caption' color='black50'>
        {children}
      </Text>
    </Box>
  </StyledDivider>
)

export default Divider
